import styled, { css } from 'styled-components'
import posed from 'react-pose'
import Icon from '../Icon'

export const StyledDrawer = styled.div`
`

const StyledDrawerWrraperPosed = posed.div({
    enter: {
        height: '100vh'
    },
    exit: {
        height: '0vh'
    }
});

export const StyledDrawerWrraper = styled(StyledDrawerWrraperPosed)`
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: 3;
    overflow: hidden;
`

export const StyledDrawerOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.blueyGrey60};
`

export const StyledDrawerContent = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.whiteTwo};
`

export const StyledDrawerItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 17.5px;
    padding-bottom: 17.5px;
`

export const StyledDrawerItemIcon = styled(Icon).attrs(({ disabled, theme }) => {
    if (disabled) {
        return {
            color: theme.lightPeach
        }
    }
})`
    width: 24px;
    height: 24px;
`

export const StyledDrawerItemWrapper = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    :focus {
        outline: 1px  solid ${({ theme }) => theme.lightPeach};;
    }
`

export const StyledDrawerItemText = styled.span`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    margin-left: 15px;
`

export const StyledDrawerItem = styled.div`
    display: flex;
    align-items: center;
    padding-top: 2.5px;
    padding-bottom: 2.5px;
    width: 100%;
    cursor: pointer;

    ${({ disabled }) =>
        disabled &&
        css`
            pointer-events: none;
            ${StyledDrawerItemText} {
                color: ${({ theme }) => theme.lightPeach};
            }
        `
    };
`

export const StyledIcon = styled(Icon).attrs(({ active, theme }) => ({
    color: active ? theme.grassyGreen : theme.brownGrey
}))`
    cursor: pointer;
`
